import { render, staticRenderFns } from "./iconBackArrow.vue?vue&type=template&id=2f2e8872&scoped=true"
import script from "./iconBackArrow.vue?vue&type=script&lang=js"
export * from "./iconBackArrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2e8872",
  null
  
)

export default component.exports